module.exports = __webpack_public_path__ + "img/email.74fda1e0.svg";